import { stringify } from 'query-string';

import { BaseQueryApi } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

let baseUrl = '<invalid>';
let accessToken: string | null = null;
let selectedTenant: string | null = null;

export const setApiAccessToken = (token: string | null) => {
  accessToken = token;
};
export const setApiBaseUrl = (url: string) => {
  baseUrl = url;
};
export const setSelectedTenant = (tenant: string | null) => {
  selectedTenant = tenant;
};
export const getApiAccessToken = () => {
  return accessToken;
};
export const getApiBaseUrl = () => {
  return baseUrl;
};

export const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: object,
) => {
  return fetchBaseQuery({
    baseUrl,
    paramsSerializer: stringify, // using stringify to convert object etc. into search string because it can handle arrays as params in this manner (e.g. array param as ?paramA=X&paramA=Y)
    prepareHeaders: (headers) => {
      // Use the module-level selectedTenant variable directly as the tenant ID
      if (selectedTenant) {
        headers.set('x-tenant-id', selectedTenant);
      } else {
        // Fallback to local storage
        const selectedTenantStorage = localStorage.getItem('exio.selectedTenant');
        if (selectedTenantStorage) {
          try {
            const parsed = JSON.parse(selectedTenantStorage);
            if (parsed.id) {
              headers.set('x-tenant-id', parsed.id);
            }
          } catch (error) {
            console.error(`Failed to parse selected tenant from local storage: ${error}`);
          }
        }
      }
      if (accessToken) headers.set('authorization', `Bearer ${accessToken}`);
      return headers;
    },
  })(args, api, extraOptions);
};

// initialize & configure api slice that is empty & will get endpoints injected into later as needed via generatedApiSlice
export const apiConfigSlice = createApi({
  keepUnusedDataFor: 60, // keep unused data for 60 seconds
  reducerPath: 'api',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['BuildingBidArea'],
  endpoints: () => ({}),
});
